module.exports = __webpack_public_path__ + "static/img/img-seguridad-vial-auto.e804972.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/seguro-autos/img-seguridad-vial-auto.png
// module id = 7kRQ
// module chunks = 0